import { BASE_ADMIN_PATH, BASE_ADMIN_V2_PATH } from '../admin/constants/path.constants';

export function isAdminRoute(pathname: string): boolean {
  const prefixes = [BASE_ADMIN_PATH, BASE_ADMIN_V2_PATH];
  return prefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}
